import { RequestKey } from "api/request-key";
import { queryClient } from "api/queryClient";

type Scope = {
  showId: string;
  standId: string;
  taskId: string;
};

/**
 * Invalidate the task-timeline react-query caches after a state change so
 * the inline history row and the timeline modal refetch. Invalidates by
 * RequestKey prefix (no stand/task scope) because callers don't always
 * hold the matching id shape; react-query only refetches active queries,
 * so the extra breadth is free.
 */
export const invalidateTaskTimelineQueries = ({
  showId,
  standId,
  taskId,
}: Scope) => {
  if (!showId || !standId || !taskId) {
    return;
  }
  queryClient.invalidateQueries({ queryKey: [RequestKey.GetTaskTimeline] });
  queryClient.invalidateQueries({
    queryKey: [RequestKey.GetTaskTimelineByType],
  });
  queryClient.invalidateQueries({
    queryKey: [RequestKey.GetLastTaskTimelineAction],
  });
};
